export default {
  props: {
    text: {
      type: String,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('showPopup');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/notification-icon/notification-icon.js